const RELATIVE_UNITS: readonly { unit: Intl.RelativeTimeFormatUnit; ms: number }[] = [
  { unit: 'day', ms: 86_400_000 },
  { unit: 'hour', ms: 3_600_000 },
  { unit: 'minute', ms: 60_000 },
];

/**
 * "2 days ago", in the parent's language.
 *
 * Produced by `Intl` rather than by a translation key: the phrasing changes with
 * the number in ways a key with an interpolated count cannot express across
 * languages, and the browser already knows the rules.
 */
export const formatLastSeen = (lastSeenAt: string, locale: string): string => {
  const elapsedMs = Date.parse(lastSeenAt) - Date.now();
  const formatter = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

  for (const { unit, ms } of RELATIVE_UNITS) {
    if (Math.abs(elapsedMs) >= ms) {
      return formatter.format(Math.round(elapsedMs / ms), unit);
    }
  }

  return formatter.format(0, 'minute');
};
